import React from 'react'
import classNames from 'classnames'

function ChipButton({ label, size, selected, onClick, ariaLabel, modifierClasses = [], thumbnail, icon }) {
  const chipClasses = classNames(
    'chip',
    {
      'chip--tiny': size === 'tiny',
      'chip--small': size === 'small',
    },
    {'is-active': selected},
    modifierClasses
  )
  return (
    <button
      aria-label={ariaLabel || label}
      className={chipClasses}
      onClick={onClick}
    >
      { Boolean(thumbnail) && (
        <div className="chip__thumbnail">{thumbnail}</div>
      )}

      <div className="chip__text">
        {label}
      </div>

      { Boolean(icon) && (
        <div className="chip__icon">{icon}</div>
      )}
    </button>
  )
}

export default ChipButton
